import React from 'react';
import { Navigate, Outlet, createBrowserRouter } from 'react-router-dom';
import PlannerHeader from '../Components/menu_planner/planner_header/PlannerHeader';
import MealPlannerLogin from '../Screens/menu_planner/login/MealPlannerLogin';
import DashboardScreen from '../Screens/menu_planner/dashboard/DashboardScreen';
import FoodBoxScreen from '../Screens/menu_planner/food_box/summary/FoodBoxScreen';
import SchedulesScreen from '../Screens/menu_planner/schedules/SchedulesScreen';
import CalenderScreen from '../Screens/menu_planner/calendar/CalenderScreen';
import NotificationScreen from '../Screens/menu_planner/notification/NotificationScreen';
import ProfileScreen from '../Screens/menu_planner/profile/ProfileScreen';
import CreateScheduleScreen from '../Screens/menu_planner/schedules/create_schedule/CreateScheduleScreen';
import CreateFoodBoxScreen from '../Screens/menu_planner/food_box/create_food_box/CreateFoodBoxScreen';
import FoodBoxSuccessScreen from '../Screens/menu_planner/food_box/food_box_success/FoodBoxSuccessScreen';
import Logout from '../Screens/menu_planner/components/Logout';
import OnBoardingPage from '../Screens/app-user-registration/OnBoardingPage';
import CreateFoodBoxMainScreen from '../Screens/menu_planner/food_box/create_food_box/CreateFoodBoxMainScreen';
import PortionFormSection from '../Screens/menu_planner/food_box/create_food_box/portion_form_section/PortionFormSection';
import FoodBoxDetailScreen from '../Screens/menu_planner/food_box/food_box_details/FoodBoxDetailScreen';
import IngredientManagementScreen from '../Screens/menu_planner/ingredient_management/IngredientManagementScreen';
import MasterDataScreen from '../Screens/menu_planner/master_data/MasterDataScreen';
import TagManagementScreen from '../Screens/menu_planner/tag_management/TagManagementScreen';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <PlannerHeader />,
    children: [
      {
        index: true,
        element: <MealPlannerLogin />,
      },
      {
        path: 'login',
        element: <MealPlannerLogin />,
      },
      {
        path: 'dashboard',
        element: <DashboardScreen />,
      },
      {
        path: 'food-boxes',
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <FoodBoxScreen />,
          },
          ...['create-food-box', 'edit-food-box'].map((path) => ({
            path,
            element: <CreateFoodBoxMainScreen />,
            children: [
              {
                index: true,
                element: <CreateFoodBoxScreen />,
              },
              {
                path: 'portion-info',
                element: <PortionFormSection />,
              },
            ],
          })),
          {
            path: 'food-box-details',
            element: <FoodBoxDetailScreen />,
          },
          {
            path: 'food-box-created-successfully',
            element: <FoodBoxSuccessScreen />,
          },
          {
            path: 'food-box-updated-successfully',
            element: <FoodBoxSuccessScreen />,
          },
        ],
      },
      {
        path: 'schedules',
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <SchedulesScreen />,
          },
          {
            path: 'main',
            element: <SchedulesScreen />,
          },
          {
            path: 'create-schedule',
            element: <CreateScheduleScreen />,
          },
        ],
      },
      {
        path: 'calendar',
        element: <CalenderScreen />,
      },
      {
        path: 'notification',
        element: <NotificationScreen />,
      },
      {
        path: 'master-data',
        element: <MasterDataScreen />,
        children: [
          {
            index: true,
            element: <Navigate to='tags' replace />,
          },
          {
            path: 'tags',
            element: <TagManagementScreen />,
          },
          {
            path: 'ingredients',
            element: <IngredientManagementScreen />,
          },
        ],
      },
      {
        path: 'ingredient-management',
        element: <Navigate to='/master-data/ingredients' replace />,
      },
      {
        path: 'tag-management',
        element: <Navigate to='/master-data/tags' replace />,
      },
      {
        path: 'profile',
        element: <ProfileScreen />,
      },
    ],
  },
  {
    path: 'logout',
    element: <Logout />,
  },
  {
    path: 'app-user-registration',
    element: <OnBoardingPage />,
  }
]);
